export default __webpack_public_path__ + "static/media/pexels-daniel-frank-287227.36a88f6f.jpg";